import { createContext, Dispatch, SetStateAction, use } from 'react';
import { ParsedData, Loan, LoanEvent } from '@/types/nsldsTypes';
import { UserSurveyData } from '@/components/survey/user-survey';
import { AllPlansResult } from '@/types/loanCalculationTypes';
import { AllPlanSummaries } from '@/types/planSummaryTypes';

export interface LoansContextType {
  parsedData: ParsedData | null;
  userParsedData: ParsedData | null;
  partnerParsedData: ParsedData | null;
  surveyData: UserSurveyData | null;
  userFile: File | null;
  partnerFile: File | null;
  setUserFile: Dispatch<SetStateAction<File | null>>;
  setPartnerFile: Dispatch<SetStateAction<File | null>>;
  userManualLoan: Loan | null;
  partnerManualLoan: Loan | null;
  // topServicer: string | null;
  showOnlyInRepayment: boolean;
  setShowOnlyInRepayment: Dispatch<SetStateAction<boolean>>;
  selectedLoan: Loan | null;
  setSelectedLoan: Dispatch<SetStateAction<Loan | null>>;
  loansByStatus: Record<string, Loan[]>;
  totalsByStatus: Record<string, number>;
  filteredLoans: Loan[];
  totalCombinedLoansCount: number;
  selectedLoanEvents: LoanEvent[];
  accordionValue: string | null;
  setAccordionValue: Dispatch<SetStateAction<string | null>>;
  modalOpen: boolean;
  setModalOpen: Dispatch<SetStateAction<boolean>>;
  isMobile: boolean;
  inflationRate: number;
  setInflationRate: Dispatch<SetStateAction<number>>;
  incomeGrowthRate: number;
  setIncomeGrowthRate: Dispatch<SetStateAction<number>>;
  taxRate: number;
  setTaxRate: Dispatch<SetStateAction<number>>;
  meetsFinancialHardship: boolean | null;
  // Navigation handlers
  handleGoBackToDataInput?: () => void; // Optional for steps that don't need it
  // Calculated values
  weightedAverageInterestRate: number;
  // Scenario calculation results and summaries
  scenarioResults: AllPlansResult[] | null;
  scenarioPlanSummaries: AllPlanSummaries | null;
  scenarioCalculationError: string | null;
  scenarioCalculationLoading: boolean;
  // New assumptions
  refiInterestRate: number;
  setRefiInterestRate: Dispatch<SetStateAction<number>>;
  refiPeriodYears: number;
  setRefiPeriodYears: Dispatch<SetStateAction<number>>;
}

export const LoansContext = createContext<LoansContextType | undefined>(undefined);

// Custom hook to use the LoansContext
export function useLoansContext(): LoansContextType {
  const context = use(LoansContext);
  if (context === undefined) {
    throw new Error('useLoansContext must be used within a LoansProvider');
  }
  return context;
}
